import { useMemo } from 'react';
import { getSafeAreaInsets } from './utils';

/**
 * Returns safe area insets for the current device.
 * Provides fallback values in server environment or for devices that don't support
 * required env variables.
 */
export const useSafeAreaInsets = () => {
  return useMemo(() => getSafeAreaInsets(), []);
};
